export function initFxTxt() {
    // Controllo rapido: Esistono testi animati?
    const hasTxtElements = document.querySelector('[data-fx-txt]');

    if (hasTxtElements) {
        import('./text/fx_txt')
            .then(({ FxTxt }) => {
                new FxTxt();
            })
            .catch(err => console.error('Error loading FxTxt:', err));
    }
}
